import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
/* global window: true, document: true */import get from 'lodash/get';
import * as Sentry from '@sentry/react';
/**
 * Handle Page Meta (title, description, ...).
 * Important note: This middleware must only be registered client-side.
 */
export var pageMetaMiddleware = function pageMetaMiddleware( /* store */
) {
  return function (next) {
    return function (action) {
      // The __SERVER__ check is only a safeguard in case this middleware is
      // registered client-side by mistake.
      // $FlowFixMe[cannot-resolve-name]
      if (__SERVER__ || !get(action, 'meta.pageMeta', false)) {
        return next(action);
      }
      try {
        var history = window.history;
        var pageMeta = get(action, 'payload.pageMeta', {});
        var newState = _objectSpread(_objectSpread({}, history.state), pageMeta);
        if (pageMeta.title) {
          // window.history.[pushState, replaceState] accepts a title argument but has no effect.
          // See https://developer.mozilla.org/en-US/docs/Web/API/History_API#The_pushState()_method
          document.title = pageMeta.title;
          history.replaceState(newState, pageMeta.title);
        }
        var metas = {
          description: pageMeta.description,
          robots: pageMeta.robots
        };
        _Object$keys(metas).forEach(function (name) {
          var content = metas[name];
          var DOMMeta = document.querySelector("meta[name=\"".concat(name, "\"]"));
          if (pageMeta[name]) {
            if (DOMMeta) {
              // $FlowFixMe[prop-missing] type HTMLMetaElement no HTMLElement
              DOMMeta.content = content;
            } else {
              var newMeta = document.querySelector('head')
              // $FlowFixMe[prop-missing]
              // $FlowFixMe[incompatible-use]
              .createElement('meta');
              newMeta.name = name;
              newMeta.content = content;
            }
          } else if (DOMMeta) {
            DOMMeta.removeChild(DOMMeta);
          }
        });
      } catch (err) {
        Sentry.captureException(err);
      }
      return next(action);
    };
  };
};
export default pageMetaMiddleware;